<template>
  <div class="menu">
    <div class="bcggg"></div>
    <div class="top">
      <div class="logo">
        <img src="../../assets/img/logo.png" alt>
      </div>
      <div class="left" @click="goPre()">
        <img src="../../assets/img/Line.png" alt>
      </div>
    </div>
    <div class="cont">
      <ul>
        <!-- v-for="(item,index) in list" -->
        <li v-for="(item,index) in arr">
          <div class="cont-tit" @click="showThis(index)">
            <div :class="{text:true,active:item.isShow}">{{item.text}}</div>
            <div :class="{icon:true,active:item.isShow}"></div>
          </div>
          <div v-if="item.list" :class="{'cont-dd': true,none:item.isShow}">
            <div v-for="val in item.list">
              <p @click="goPath(val.path)">{{ val.p }}</p>
            </div>
          </div>
        </li>
      </ul>
    </div>

    <!-- 按钮 -->
    <div class="bott">
      <div @click="goRegister()" class="left">{{ $t("a1") }}</div>
      <div @click="goLogin()" class="right">{{ $t("a40") }}</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      // list: [
      //   {
      //     text: this.$t("a31")
      //   }
      // ]
      arr: [
        {
          text: this.$t("a31"),
          isShow: false,
          list: []
        },
        {
          text: this.$t("a32"),
          isShow: false,
          list: [
            {
              p: this.$t("a5"),
              path: "/register"
            },
            {
              p: this.$t("a41"),
              path: "/deposit"
            },
            {
              p: this.$t("a42"),
              path: "/withdraw"
            }
          ]
        },
        {
          text: this.$t("a33"),
          isShow: false,
          list: [
            {
              p: this.$t("a43"),
              path: "/dowpla"
            },
            {
              p: this.$t("a44"),
              path: "/spec"
            },
            {
              p: this.$t("a45"),
              path: "/overnight"
            }
          ]
        },
        {
          text: this.$t("a34"),
          isShow: false,
          list: [
            {
              p: this.$t("a46"),
              path: "/glossary"
            },
            {
              p: this.$t("a11"),
              path: "/videos"
            }
          ]
        },
        {
          text: this.$t("a35"),
          isShow: false,
          list: [
            {
              p: this.$t("a6"),
              path: "/license"
            },
            {
              p: this.$t("a47"),
              path: "/legal"
            }
          ]
        },
        {
          text: this.$t("a36"),
          isShow: false,
          list: [
            {
              p: this.$t("a48"),
              path: "/generic"
            },
            {
              p: this.$t("a49"),
              path: "/taq"
            },
            {
              p: this.$t("a50"),
              path: "/dw"
            },
            {
              p: this.$t("a51"),
              path: "/gtq"
            }
          ]
        },
        {
          text: this.$t("a37"),
          isShow: false,
          list: [
            {
              p: this.$t("a37"),
              path: "/about"
            },
            {
              p: this.$t("a52"),
              path: "/contact"
            }
          ]
        },
        {
          text: this.$t("a38"),
          isShow: false,
          list: []
        },
        {
          text: this.$t("a58"),
          isShow: false,
          list: []
        }
      ],
      flag: 999
    };
  },
  computed: {
    getList() {}
  },
  methods: {
    goPre() {
      this.$router.go(-1);
    },
    goRegister() {
      this.$router.push("/register");
    },
    goLogin() {
      this.$router.push("/login");
    },
    showThis(id) {
      switch (id) {
        case 0:
          this.$router.push("/home");
          return;
          break;
        case 7:
          this.$router.push("/chat");
          return;
          break;
        case 8:
          this.$router.push("/language");
          return;
          break;

        default:
          break;
      }
      this.arr.forEach((a, i) => {
        this.$set(a, "isShow", false);
        if (this.flag != id) {
          this.flag = id;
          this.$set(this.arr[id], "isShow", true);
        } else {
          this.flag = 999;
          this.$set(this.arr[id], "isShow", false);
        }
      });
    },
    goPath(path) {
      this.$router.push(path);
    }
  }
};
</script>

<style src='./menu.less' lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Menu/menu.vue